import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import ClientesTabs from '../components/ClientesTabs';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import {
    listarSaldos, recordarATodos, pesos, fechaCorta, motivoNoEnvio, textoUltimoRecordatorio, resumenEnvio, aplicarResultados, ultimoEnvioTras,
} from '../utils/storeCreditReminder';

// Clientes → Saldos a favor: todos los clientes con saldo, cuánto se les debe en total, y el
// botón para recordarles el saldo por mail a todos juntos. El recordatorio de UN cliente está en
// su detalle (pedido del dueño), no acá.
class StoreCreditsPage extends Component {

    constructor() {
        super();
        this.state = {
            checked: false, role: 0,
            cargando: true, error: null, datos: null,
            confirmando: false, incluirRecientes: false,
            enviando: false, resultado: null,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
        this.cargar();
    }

    cargar = async () => {
        this.setState({ cargando: true, error: null });
        try {
            const datos = await listarSaldos();
            this.setState({ datos, cargando: false });
        } catch (e) {
            this.setState({ error: e.message, cargando: false });
        }
    }

    enviar = async () => {
        this.setState({ enviando: true, resultado: null });
        try {
            const resultado = await recordarATodos(this.state.incluirRecientes);
            this.setState((s) => ({
                enviando: false, confirmando: false, incluirRecientes: false, resultado,
                datos: s.datos ? {
                    ...s.datos,
                    clientes: aplicarResultados(s.datos.clientes, resultado.resultados),
                    ultimoEnvio: ultimoEnvioTras(s.datos.ultimoEnvio, resultado.resultados),
                } : s.datos,
            }));
        } catch (e) {
            this.setState({ enviando: false, resultado: { error: e.message } });
        }
    }

    renderConfirmacion(clientes, diasReciente) {
        const { incluirRecientes, enviando } = this.state;
        const r = resumenEnvio(clientes, incluirRecientes);
        return (
            <div className="alert alert-light border mb-0 mt-3" role="alert">
                <p className="mb-2">
                    <strong>Se le va a mandar el recordatorio a {r.aEnviar} {r.aEnviar === 1 ? 'cliente' : 'clientes'}</strong>, cada uno con su saldo.
                </p>
                <ul className="mb-2">
                    {r.sinMail > 0 && <li>{r.sinMail} sin mail: no se les manda.</li>}
                    {r.aRevisar > 0 && <li>{r.aRevisar} con un mail inválido o con tipeo: no se les manda hasta corregirlo en su ficha.</li>}
                    {r.recientes > 0 && (
                        <li>
                            {r.recientes} ya recibieron un recordatorio en los últimos {diasReciente} días.{' '}
                            <label className="mb-0" style={{ cursor: 'pointer' }}>
                                <input type="checkbox" checked={incluirRecientes} disabled={enviando}
                                    onChange={(e) => this.setState({ incluirRecientes: e.target.checked })} />
                                {' '}Mandarles igual
                            </label>
                        </li>
                    )}
                </ul>
                <button type="button" className="btn btn-accent mr-2" disabled={enviando || r.aEnviar === 0} onClick={this.enviar}>
                    {enviando ? 'Enviando… puede tardar unos segundos' : `Mandar ${r.aEnviar} ${r.aEnviar === 1 ? 'mail' : 'mails'}`}
                </button>
                <button type="button" className="btn btn-white" disabled={enviando}
                    onClick={() => this.setState({ confirmando: false, incluirRecientes: false })}>Cancelar</button>
            </div>
        );
    }

    renderResultado() {
        const { resultado } = this.state;
        if (!resultado) return null;
        if (resultado.error) {
            return <div className="alert alert-danger mt-3 mb-0">No se pudo hacer el envío: {resultado.error}</div>;
        }
        const fallidos = (resultado.resultados || []).filter((x) => x.estado !== 'enviado');
        return (
            <div className={`alert ${fallidos.length ? 'alert-warning' : 'alert-success'} mt-3 mb-0`}>
                Se {resultado.enviados === 1 ? 'envió' : 'enviaron'} <strong>{resultado.enviados}</strong> {resultado.enviados === 1 ? 'recordatorio' : 'recordatorios'}.
                {fallidos.length > 0 && <span> No salieron {fallidos.length}: {fallidos.map((x) => x.email).join(', ')}. Se pueden reintentar desde el detalle de cada cliente.</span>}
            </div>
        );
    }

    render() {
        if (!this.state.checked) return (<div></div>);
        const { cargando, error, datos, confirmando, enviando } = this.state;
        const clientes = (datos && datos.clientes) || [];
        const diasReciente = (datos && datos.diasReciente) || 30;
        const noSeLesEscribe = clientes.filter((c) => !c.mail || !c.mail.enviable).length;

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={3} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Clientes" subtitle="Saldos a favor" />
                            <ClientesTabs active="/storeCredits" />

                            {cargando && <div className="card card-small mb-4"><div className="card-body p-4 text-center">Cargando…</div></div>}
                            {!cargando && error && <div className="alert alert-danger">{error}</div>}

                            {!cargando && datos && (
                                <React.Fragment>
                                    <div className="card card-small mb-4">
                                        <div className="card-body p-4">
                                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                                                <div className="mb-2">
                                                    <h6 className="text-uppercase text-muted mb-1">Total en saldos a favor</h6>
                                                    <h3 className="mb-0">{pesos(datos.total)}</h3>
                                                    <small className="text-muted">
                                                        {datos.cantidad} {datos.cantidad === 1 ? 'cliente' : 'clientes'}
                                                        {noSeLesEscribe > 0 ? ` · ${noSeLesEscribe} sin un mail al que se le pueda escribir` : ''}
                                                    </small>
                                                </div>
                                                <div className="text-right mb-2">
                                                    {!confirmando && (
                                                        <button type="button" className="btn btn-accent" disabled={clientes.length === 0}
                                                            onClick={() => this.setState({ confirmando: true, resultado: null })}>
                                                            Recordar saldo a todos
                                                        </button>
                                                    )}
                                                    <div>
                                                        <small className="text-muted">
                                                            Último recordatorio: {datos.ultimoEnvio ? fechaCorta(datos.ultimoEnvio) : 'Nunca'}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                            {confirmando && this.renderConfirmacion(clientes, diasReciente)}
                                            {this.renderResultado()}
                                        </div>
                                    </div>

                                    <div className="card card-small mb-4">
                                        <div className="card-body p-0">
                                            <table className="table mb-0">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th>Cliente</th>
                                                        <th>Cédula</th>
                                                        <th>Mail</th>
                                                        <th className="text-right">Saldo</th>
                                                        <th>Último recordatorio</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientes.length === 0 && (
                                                        <tr><td colSpan="5" className="text-center text-muted">Ningún cliente tiene saldo a favor.</td></tr>
                                                    )}
                                                    {clientes.map((c) => {
                                                        const motivo = motivoNoEnvio(c.mail);
                                                        return (
                                                            <tr key={c.cedula}>
                                                                <td>
                                                                    {/* Un saldo sin ficha (cédula sin alta de cliente) no tiene detalle al que ir. */}
                                                                    {c.tieneFicha
                                                                        ? (
                                                                            <button type="button" className="btn btn-link p-0" disabled={enviando}
                                                                                onClick={() => navigateTo(`/clientDetail?cedula=${encodeURIComponent(c.cedula)}`)}>
                                                                                {c.nombre || '(sin nombre)'}
                                                                            </button>
                                                                        )
                                                                        : <span className="text-muted">(sin ficha)</span>}
                                                                </td>
                                                                <td>{c.cedula}</td>
                                                                <td>
                                                                    {c.email && c.email !== '-' ? <span className={motivo ? 'text-muted' : ''}>{c.email}</span> : null}
                                                                    {motivo && <span className="badge badge-warning ml-1">{motivo} · no se le envía</span>}
                                                                </td>
                                                                <td className="text-right">{pesos(c.saldo)}</td>
                                                                <td>{textoUltimoRecordatorio(c.recordatorio)}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default StoreCreditsPage;
